/**
 * Chailease.SystemParameter.API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { BusinessGroupSettingViewModel } from '../model/businessGroupSettingViewModel';
import { DeliveryGroupViewModel } from '../model/deliveryGroupViewModel';
import { ProblemDetails } from '../model/problemDetails';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BusinessGroupSettingService {

    protected basePath = 'http://ch-demo-apigw.chailease.com.tw/dev-backdoor/retail-system-parameter-service';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * [Private] 查詢業務群組維護設定清單
     * 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessGroupSettingEnquiryPost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<BusinessGroupSettingViewModel>>;
    public businessGroupSettingEnquiryPost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<BusinessGroupSettingViewModel>>>;
    public businessGroupSettingEnquiryPost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<BusinessGroupSettingViewModel>>>;
    public businessGroupSettingEnquiryPost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<BusinessGroupSettingViewModel>>('post',`${this.basePath}/BusinessGroupSetting/Enquiry`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 取得派件群組資料
     * 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessGroupSettingGetDeliveryGroupSettingDataPost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<Array<DeliveryGroupViewModel>>;
    public businessGroupSettingGetDeliveryGroupSettingDataPost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<DeliveryGroupViewModel>>>;
    public businessGroupSettingGetDeliveryGroupSettingDataPost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<DeliveryGroupViewModel>>>;
    public businessGroupSettingGetDeliveryGroupSettingDataPost(xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {







        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.request<Array<DeliveryGroupViewModel>>('post',`${this.basePath}/BusinessGroupSetting/GetDeliveryGroupSettingData`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * [Private] 儲存業務群組維護設定
     * 
     * @param body 
     * @param xFromChannel From Channel (Example: Web、APP...)
     * @param xClientTraceId Client side UUID
     * @param xServerTraceId Server side UUID
     * @param xClientDate Request time
     * @param xUserNo Request UserNo
     * @param xAuditInfo Use Audit Flow
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public businessGroupSettingSavePost(body?: BusinessGroupSettingViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'body', reportProgress?: boolean): Observable<BusinessGroupSettingViewModel>;
    public businessGroupSettingSavePost(body?: BusinessGroupSettingViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<BusinessGroupSettingViewModel>>;
    public businessGroupSettingSavePost(body?: BusinessGroupSettingViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<BusinessGroupSettingViewModel>>;
    public businessGroupSettingSavePost(body?: BusinessGroupSettingViewModel, xFromChannel?: string, xClientTraceId?: string, xServerTraceId?: string, xClientDate?: string, xUserNo?: string, xAuditInfo?: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {








        let headers = this.defaultHeaders;
        if (xFromChannel !== undefined && xFromChannel !== null) {
            headers = headers.set('X-From-Channel', String(xFromChannel));
        }
        if (xClientTraceId !== undefined && xClientTraceId !== null) {
            headers = headers.set('X-Client-TraceId', String(xClientTraceId));
        }
        if (xServerTraceId !== undefined && xServerTraceId !== null) {
            headers = headers.set('X-Server-TraceId', String(xServerTraceId));
        }
        if (xClientDate !== undefined && xClientDate !== null) {
            headers = headers.set('X-Client-Date', String(xClientDate));
        }
        if (xUserNo !== undefined && xUserNo !== null) {
            headers = headers.set('X-UserNo', String(xUserNo));
        }
        if (xAuditInfo !== undefined && xAuditInfo !== null) {
            headers = headers.set('X-Audit-Info', String(xAuditInfo));
        }

        // authentication (Bearer) required
        if (this.configuration.apiKeys && this.configuration.apiKeys["Authorization"]) {
            headers = headers.set('Authorization', this.configuration.apiKeys["Authorization"]);
        }

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<BusinessGroupSettingViewModel>('post',`${this.basePath}/BusinessGroupSetting/Save`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
